module.exports = __webpack_public_path__ + "media/components/Videos/icon_warning_circle-78adabf87cfb35bccec4c0b3d3e0153c.svg";